export function getTokenId(token) {
    return token?.tokenId || token?.token_id || token?.id || 0;
}

export function getPartnerId(token) {
    return token?.partnerId || token?.partner_id || 0;
}

function getScatter(index) {
    const rotations = [-9, 6, -4, 10];
    const y = [0, -9, 5, -6];
    const x = [0, -4, 3, -2];

    return {
        '--bjnt-sticker-rotate': `${rotations[index % rotations.length]}deg`,
        '--bjnt-sticker-y': `${y[index % y.length]}px`,
        '--bjnt-sticker-x': `${x[index % x.length]}px`,
    };
}

export default function GiveawayStickerBundle({
    tokens = [],
    label = 'Sticker',
    variant = 'slot',
    disabled = false,
    onClick,
}) {
    const visibleTokens = tokens.filter(Boolean);

    if (!visibleTokens.length) return null;

    const shown = visibleTokens.slice(0, 4);
    const extra = visibleTokens.length - shown.length;

    return (
        <button
            type="button"
            className={[
                'bjnt-giveaway-sticker-bundle',
                `bjnt-giveaway-sticker-bundle--${variant}`,
                visibleTokens.length > 1 ? 'bjnt-giveaway-sticker-bundle--multi' : '',
            ].join(' ')}
            disabled={disabled}
            onClick={onClick}
            aria-label={`Collect ${visibleTokens.length > 1 ? `${visibleTokens.length} stickers` : (visibleTokens[0]?.name || label)}`}
        >
            <span className="bjnt-giveaway-sticker-bundle__row">
                {shown.map((token, index) => (
                    <span
                        key={`${getTokenId(token) || token.claimToken || index}-${index}`}
                        className="bjnt-giveaway-sticker"
                        style={getScatter(index)}
                    >
                        <span className="bjnt-giveaway-sticker__spark">✦</span>

                        <span className="bjnt-giveaway-sticker__shape">
                            {token.imageUrl ? (
                                <img src={token.imageUrl} alt={token.name || label} />
                            ) : (
                                <span className="bjnt-giveaway-sticker__fallback">
                                    {token.name || label}
                                </span>
                            )}
                        </span>
                    </span>
                ))}

                {extra > 0 && (
                    <span className="bjnt-giveaway-sticker-bundle__more">
                        +{extra}
                    </span>
                )}
            </span>
        </button>
    );
}